<template>
  <div>
    <div class="modal info-modal" :class="{'is-active': showDisclaimer}">
      <div class="modal-background" @click="showDisclaimer = false"></div>
      <div class="modal-content">
        <!-- Any other Bulma elements you want -->
        <div class="box">
          <p class="modal-title">Disclaimer</p>
          <p>
            All pricing and availability subject to change; to confirm pricing please visit the builder's website or
            with a sales counselor on-site.
          </p>
          <a class="button app-accent" @click="showDisclaimer = false">Got It</a>
        </div>
        <button class="modal-close is-large" aria-label="close"></button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'app-disclaimer',
  data() {
    return {
      showDisclaimer: false
    }
  },
  mounted() {
    this.checkPageView();
  },
  methods: {
    checkPageView: function () {
      const view = localStorage.getItem('pageView');
      if (!view) {
        localStorage.setItem('pageView', '1');
        this.showDisclaimer = true;
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/journey/Disclaimer.vue